'use strict';

var $                   = require('jquery');
var Core                = require('../core/core.js');
var ModalButton         = require('./modal__button.js');

/**
 * Creates a Tab
 *
 * @class
 */

class ModalButtonRow extends Core {

    _defaults() {
        return {
            target: '',
            fields: {
                'text': '',
                'subtext': ''
            }
        };
    }

    constructor(options) {
        super(options);

       this.template = `
            <div class='editor__modal__body__row'>
                <% if(text != "") { %>
                    <div class='editor__modal__body__row__title'>
                        <%- text %>
                    </div>
                <% } %>
                <% if(subtext != "") { %>
                    <div class='editor__modal__body__row__subtext'>
                         <%- subtext %>
                    </div>
                <% } %>
                <div class='editor__modal__body__row__buttonarea'>
                    <div class='editor__modal__body__row__buttonarea_buttons'>
                    <div>
                <div>
            </div>
        `;

        super.render();
    }


    addButton( title, style){
        return new ModalButton({
            target: $(".editor__modal__body__row__buttonarea_buttons", this.$el),
            fields: {
                'title': title,
                'style': style
            }
        });
    }

    addText( text ){
        return $(".editor__modal__body__row__buttonarea", this.$el).append("<div class='editor__modal__body__row__buttonarea__issue'>" + text +"<div>")
    }

    appendSubtext( text ){
        return $(".editor__modal__body__row__subtext", this.$el).append("<div class='editor__modal__body__row__subtext__secondrow'>" + text +"<div>")
    }

}
module.exports = ModalButtonRow;